import { useState, useEffect } from "react";

const useUserIp = () => {
  const [userIp, setUserIp] = useState("");

  useEffect(() => {
    const fetchIp = async () => {
      try {
        const res = await fetch("https://api.ipify.org?format=json", {
          method: "GET",
          headers: {}
        });

        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }

        const data = await res.json();
        setUserIp(data.ip);
      } catch (fetchError) {
        setUserIp("");
      }
    };

    fetchIp();
  }, []);

  return { userIp };
};

export default useUserIp;
